// removed by extract-text-webpack-plugin
module.exports = {"container":"AdminHeader__container__2X7lj","leftSection":"AdminHeader__leftSection__26EzI","appName":"AdminHeader__appName__1YY0Y","terminalName":"AdminHeader__terminalName__3hYfF","clearFix":"AdminHeader__clearFix__1ZQPA","rightSection":"AdminHeader__rightSection__1_Sby","userInfo":"AdminHeader__userInfo__1pb69","clock":"AdminHeader__clock__1LyVi","logo":"AdminHeader__logo__3k9lm"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/AdminHeader/AdminHeader.css
// module id = 562
// module chunks = 0